var _rect, _circle, _line, _line2, _line3, _line4, _line5, _rect2, _circle2, _circle3, _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    rx: 16,
    fill: "#f0fdfa"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 68,
    r: 20,
    fill: "#ccfbf1",
    stroke: "#0d9488",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 88,
    x2: 200,
    y2: 160,
    stroke: "#0d9488",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 115,
    x2: 155,
    y2: 95,
    stroke: "#0d9488",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 115,
    x2: 245,
    y2: 95,
    stroke: "#0d9488",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 160,
    x2: 165,
    y2: 215,
    stroke: "#0d9488",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 160,
    x2: 235,
    y2: 215,
    stroke: "#0d9488",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 82,
    width: 22,
    height: 9,
    rx: 3,
    fill: "#14b8a6",
    opacity: 0.35
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 87,
    r: 7,
    fill: "#14b8a6",
    opacity: 0.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 157,
    cy: 87,
    r: 7,
    fill: "#14b8a6",
    opacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M258 105 C265 100 272 105",
    stroke: "#0d9488",
    strokeWidth: 1.5,
    fill: "none",
    opacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262 113 C269 108 276 113",
    stroke: "#0d9488",
    strokeWidth: 1.5,
    fill: "none",
    opacity: 0.2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 262,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#115e59"
  }, "Fizik Tedavi")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysio);
export default __webpack_public_path__ + "static/media/physio.8de38571d7d921087c7ef395b40ad107.svg";
export { ForwardRef as ReactComponent };